<template>
  <div class="container">
    <h4>美团核销设置</h4>
    <div class="list">
      <div  class="list-item">
        <div>
          <span class="label" style="margin-right: 20px">已核套餐检测</span>
          <span class="label">dealGroupId</span>
          <el-tag
              :key="tag"
              v-for="tag in receipt.dealIds"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, 'receipt')">
            {{tag}}
          </el-tag>
          <el-input
              class="input-new-tag"
              v-if="receiptInputVisible"
              v-model="receiptInputValue"
              ref="receiptInput"
              size="small"
              @keyup.enter.native="handleInputConfirm('receipt')"
              @blur="handleInputConfirm('receipt')"
          />
          <el-button v-else class="button-new-tag"  size="small" @click="showInput('receipt')"  style="margin-right: 50px">+ 新增</el-button>

          <span style="word-break: break-all; white-space: nowrap;">
            <span class="label">状态</span>
            <el-switch v-model="receipt.status" :active-value="1" :inactive-value="0"></el-switch>
          </span>
        </div>
      </div>
      <div  class="list-item">
        <div>
          <span class="label" style="margin-right: 20px">标记代金券</span>
          <span class="label">dealGroupId</span>
          <el-tag
              :key="tag"
              v-for="tag in voucher.dealIds"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, 'voucher')">
            {{tag}}
          </el-tag>
          <el-input
              class="input-new-tag"
              v-if="voucherInputVisible"
              v-model="voucherInputValue"
              ref="voucherInput"
              size="small"
              @keyup.enter.native="handleInputConfirm('voucher')"
              @blur="handleInputConfirm('voucher')"
          />
          <el-button v-else class="button-new-tag"  size="small" @click="showInput('voucher')"  style="margin-right: 50px">+ 新增</el-button>

          <span style="word-break: break-all; white-space: nowrap;">
            <span class="label">状态</span>
            <el-switch v-model="voucher.status" :active-value="1" :inactive-value="0"></el-switch>
          </span>
        </div>
      </div>
    </div>

    <el-button
        type="primary"
        class="save-btn"
        @click="handleSave"
        :loading="saving"
    >保存
    </el-button>
  </div>
</template>

<script>


export default {
  data() {
    return {
      receipt: {
        status: 0,
        dealIds: [],
      },
      voucher:{
        status: 0,
        dealIds: [],
      },
      receiptInputVisible: false,
      receiptInputValue: '',
      voucherInputVisible: false,
      voucherInputValue: '',
      saving: false,
      editingType: '' // 'receipt' 或 'voucher'
    }
  },
  mounted() {
    this.handleGetConfig()
  },
  methods: {

    // 获取配置
    handleGetConfig() {
      this.$http.get("market/meituan").then(({data}) => {
        this.receipt = data.data.receipt
        this.voucher = data.data.voucher || this.voucher
      })
    },

    handleClose(tag, type) {
      if (type === 'receipt') {
        this.receipt.dealIds.splice(this.receipt.dealIds.indexOf(tag), 1);
      } else if (type === 'voucher') {
        this.voucher.dealIds.splice(this.voucher.dealIds.indexOf(tag), 1);
      }
    },

    showInput(type) {
      if (type === 'receipt') {
        this.receiptInputVisible = true;
        this.$nextTick(() => {
          this.$refs.receiptInput?.focus();
        });
      } else if (type === 'voucher') {
        this.voucherInputVisible = true;
        this.$nextTick(() => {
          this.$refs.voucherInput?.focus();
        });
      }
    },

    handleInputConfirm(type) {
      if (type === 'receipt') {
        const value = this.receiptInputValue.trim();
        if (value && !this.receipt.dealIds.includes(value)) {
          this.receipt.dealIds.push(value);
        }
        this.receiptInputVisible = false;
        this.receiptInputValue = '';
      }

      if (type === 'voucher') {
        const value = this.voucherInputValue.trim();
        if (value && !this.voucher.dealIds.includes(value)) {
          this.voucher.dealIds.push(value);
        }
        this.voucherInputVisible = false;
        this.voucherInputValue = '';
      }
    },

    // 保存设置
    handleSave() {
      this.saving = true;
      this.$http.post("market/meituan", JSON.stringify({
        receipt: this.receipt,
        voucher: this.voucher
      })).then(({data}) => {
        this.saving = false;
        this.$message.success('保存成功');
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

h4 {
  margin: 20px 0 15px;
  color: #333;
  font-size: 16px;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.radio {
  margin-right: 15px;
}

.input {
  width: 180px;
  margin-right: 15px;
}

.ratio-label, .label {
  margin-right: 10px;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.delete-btn {
  float: right;
}

.add-btn {
  margin: 10px 0;
  color: #409EFF;
}

.save-btn {
  display: block;
  margin: 50px auto 0;
  width: 200px;
}


 .el-tag + .el-tag {
   margin-left: 10px;
 }
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

</style>
